const localizedEbook = function() {
	const twitUrl = "https://twitter.com/share?url=";
	const fbOnClick = "window.open('https://www.facebook.com/sharer/sharer.php?u=##EBOOKURL##','facebook-share-dialog','width=626,height=436'); return false;";
	const linkedUrl = "https://www.linkedin.com/shareArticle?mini=true&url=";
	const pinUrl = "https://www.pinterest.com/pin/create/button/?url=";
	
	const fbOnClickfunc = (url) =>{ 
		var newUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + url
		window.open(newUrl,'facebook-share-dialog','width=626,height=436'); 
		return false;	
	};

	return {
		TwitUrl: twitUrl,
		FbOnClick: fbOnClick,
		LinkedUrl: linkedUrl,
		PinUrl: pinUrl,
		FbFunc: fbOnClickfunc
	};
};